var localCommonConfig = {
  screenDimensions: {
    android: {
      mobile: {
        long: 1920,
        short: 1080,
        min: 420
      },
      tablet: {
        long: 1280,
        short: 800,
        min: 800
      }
    },
    ios: {
      mobile: {
        long: 1136,
        short: 640,
        min: 640
      },
      tablet: {
        long: 1024,
        short: 768,
        min: 768
      }
    }
  },
  firstNetSubmissionFAQ: '/faq',
  setDevPortalDeepLink: function(pagePath) {
    return this.devPortal + '&destPage=' + encodeURIComponent(pagePath);
  },
  createDevPortalLinks: function() {
    this.manageAccount = this.setDevPortalDeepLink('/developer/mvc/manageMyAccount');
    this.changePassword = this.setDevPortalDeepLink('/developer/mvc/user/manageProfile');
    this.resourceCatalog = this.setDevPortalDeepLink('/firstnet/resources/downloadable-resources');
    this.devMarketingYourApp = this.setDevPortalDeepLink('/firstnet/resources/distribution');
    this.devUploadingYourApp = this.setDevPortalDeepLink('/firstnet/resources/submission');
    this.devCertificationAccrediation = this.setDevPortalDeepLink('/firstnet/resources/program-governance');
    // this.devGeneralChecklistForm = this.setDevPortalDeepLink('/static-assets/documents/firstnet/resources-downloadable-resources/Listed_App_Checklist.xlsx');
    // this.devCertifiedChecklistForm = this.setDevPortalDeepLink('/static-assets/documents/firstnet/firstnet-ioc-2/resources-downloadable-resources/Certified_App_Checklist.xlsx');
    //this.devSourceCodeScanInfo = this.setDevPortalDeepLink('/static-assets/documents/firstnet/firstnet-ioc-2/resources-downloadable-resources/FirstNet_Application_Testing_and_Security_Requirements.pdf');
    this.devDevelopmentDistribution = this.setDevPortalDeepLink('/firstnet/resources');
    this.devCertificationDetails = this.setDevPortalDeepLink('/firstnet/resources/submission');
  }
}

export default localCommonConfig
